export default {
  computed: {
    hideGmapAutocomplete() {
      const hideMap = this.$store.state.checkoutFields.ADDRESS_INFO_FIELDS.find(
        (e) => e.name === 'HIDE_MAP'
      )
      return Boolean(hideMap)
    },
  },
}
